import React from 'react';
import { Layout } from 'fronton-react';
import { RootLayout } from 'common/components';
import { ConsultationSection } from 'remotes/consultation-section';
import { SpecialOffer } from 'remotes/special-offer';
import { PromoBlock } from 'remotes/promo-block';
import {
  FeaturesSection,
  GallerySection,
  HeaderSection,
  ProjectDevelopmentSection,
  ProjectServicesTypesSection,
  STEPS_LIST,
  StepsSection,
} from '../components';
import {
  DEFAULT_CONSULTATION_SECTION_TITLE,
  DEFAULT_CONSULTATION_SUB_CHANNEL,
} from '../engineering-systems-constants';
import { EngineeringSystemTypeProps } from '../engineering-systems-types';
import { POWER_SUPPLY_GALLERY_LIST } from './components/gallery-section';
import { POWER_SUPPLY_HEADER_SECTION_CONFIG } from './components/header-section';
import {
  POWER_SUPPLY_DEVELOPMENT,
  POWER_SUPPLY_PROJECT_TYPE_LIST,
} from './components/project-types-section';
import {
  POWER_SUPPLY_ELEMENT_BLOCK,
  POWER_SUPPLY_SYSTEMS_CONSULTATION_TYPE,
  POWER_SUPPLY_SYSTEMS_PATH,
} from './power-supply-systems-constants';

/**
 * Вью страницы "Системы электроснабжения"
 */
export const PowerSupplySystems = ({
  consultationSectionRef,
  onConsultationSignupBtnClick,
  serviceTypePrice,
}: EngineeringSystemTypeProps) => (
  <RootLayout currentPage={POWER_SUPPLY_SYSTEMS_PATH}>
    <Layout>
      <HeaderSection
        headerConfig={POWER_SUPPLY_HEADER_SECTION_CONFIG}
        onConsultationSignupBtnClick={onConsultationSignupBtnClick}
      />
      <FeaturesSection />
      <PromoBlock elementBlock={POWER_SUPPLY_ELEMENT_BLOCK} />
      <SpecialOffer
        onModalBtnClick={onConsultationSignupBtnClick}
        elementBlock={POWER_SUPPLY_ELEMENT_BLOCK}
      />
      {serviceTypePrice && Object.keys(serviceTypePrice).length > 1 ? (
        <ProjectServicesTypesSection
          elementBlock={POWER_SUPPLY_ELEMENT_BLOCK}
          onConsultationSignupBtnClick={onConsultationSignupBtnClick}
          projectTypeList={POWER_SUPPLY_PROJECT_TYPE_LIST}
          serviceTypePrice={serviceTypePrice}
        />
      ) : (
        <ProjectDevelopmentSection
          elementBlock={POWER_SUPPLY_ELEMENT_BLOCK}
          onConsultationSignupBtnClick={onConsultationSignupBtnClick}
          projectDevelopmentInfo={POWER_SUPPLY_DEVELOPMENT}
          serviceTypePrice={serviceTypePrice}
        />
      )}
      <StepsSection stepSectionList={STEPS_LIST} />
      <GallerySection
        elementBlock={POWER_SUPPLY_ELEMENT_BLOCK}
        galleryList={POWER_SUPPLY_GALLERY_LIST}
        onConsultationSignupBtnClick={onConsultationSignupBtnClick}
      />
      <ConsultationSection
        consultationType={POWER_SUPPLY_SYSTEMS_CONSULTATION_TYPE}
        elementBlock={POWER_SUPPLY_ELEMENT_BLOCK}
        elementText="Заявка на консультацию"
        sectionRef={consultationSectionRef}
        sectionTitle={DEFAULT_CONSULTATION_SECTION_TITLE}
        subChannel={DEFAULT_CONSULTATION_SUB_CHANNEL}
      />
    </Layout>
  </RootLayout>
);
